const API_BASE = "https://api.lexikonn.eu/amnesia";

function getAuthToken() {
    try {
        return localStorage.getItem("amnesia_auth_token");
    } catch {
        return null;
    }
}

export async function apiGet(path, opts = {}) {
    const token = getAuthToken();
    const headers = opts.headers ? { ...opts.headers } : {};
    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    const r = await fetch(`${API_BASE}${path}`, {
        credentials: "include",
        ...opts,
        headers
    });
    return r.json();
}

export const API_BASE_URL = API_BASE;

export async function apiPost(path, data) {
    const token = getAuthToken();
    const headers = { "Content-Type": "application/json" };
    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    const r = await fetch(`${API_BASE_URL}${path}`, {
        method: "POST",
        credentials: "include",
        headers,
        body: JSON.stringify(data)
    });
    const text = await r.text();
    let json;
    try {
        json = JSON.parse(text);
    } catch {
        json = { ok: false, error: `bad_json_response: ${text.slice(0, 200)}` };
    }
    return json;
}

export async function logout() {
    const token = getAuthToken();
    const headers = {};
    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    const r = await fetch(`${API_BASE_URL}/logout.php`, {
        method: "POST",
        credentials: "include",
        headers
    });
    return r.json();
}
